/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AnalyticsReport } from '../models/AnalyticsReport';
import type { AnalyticsReportFilterType } from '../models/AnalyticsReportFilterType';
import type { AnalyticsReportType } from '../models/AnalyticsReportType';
import type { CompanyRefreshStatus } from '../models/CompanyRefreshStatus';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AnalyticsService {

    /**
     * Returns the list of Reports for user to view
     * @returns any Success
     * @throws ApiError
     */
    public static getAnalyticsReportsList({
        search,
        limit,
        offset,
        sort,
        reportType,
        filterType,
    }: {
        /**
         * Filter by Report name
         */
        search?: string,
        /**
         * Max Reports per page
         */
        limit?: number,
        /**
         * Page number
         */
        offset?: number,
        /**
         * Sorting options
         */
        sort?: Record<string, any>,
        /**
         * Filter by Report Type
         */
        reportType?: AnalyticsReportType,
        /**
         * Filter by Last Seen Or Favourites or All reports (without filtering)
         */
        filterType?: AnalyticsReportFilterType,
    }): CancelablePromise<{
        metadata: {
            totalData: number;
        };
        results: Array<AnalyticsReport>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/report',
            query: {
                'search': search,
                'limit': limit,
                'offset': offset,
                'sort': sort,
                'reportType': reportType,
                'filterType': filterType,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                423: `The specified resource is unavailable`,
            },
        });
    }

    /**
     * Returns the Company Refresh Status
     * @returns CompanyRefreshStatus Success
     * @throws ApiError
     */
    public static getNamespaceRefreshStatus(): CancelablePromise<CompanyRefreshStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/analytics/companyStatus',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                423: `The specified resource is unavailable`,
            },
        });
    }

    /**
     * Add Analytics Report to user's favourite
     * @returns any Success
     * @throws ApiError
     */
    public static addFavouriteAnalyticsReport({
        reportId,
    }: {
        /**
         * Analytics Report ID
         */
        reportId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/analytics/{reportId}/favourite',
            path: {
                'reportId': reportId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
                423: `The specified resource is unavailable`,
            },
        });
    }

    /**
     * Removes Analytics Report From Favourite
     * @returns any Success
     * @throws ApiError
     */
    public static removeFavouriteAnalyticsReport({
        reportId,
    }: {
        /**
         * Analytics Report ID
         */
        reportId: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/analytics/{reportId}/favourite',
            path: {
                'reportId': reportId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
